import { useState, useEffect } from 'react';
import { getPricing, PricingConfig } from '@/config/pricing';

/**
 * Hook React qui récupère les prix depuis #app-data-pricing
 * et observe les changements pour mettre à jour automatiquement
 */
export function usePricing(): PricingConfig {
  const [pricing, setPricing] = useState<PricingConfig>(getPricing());

  useEffect(() => {
    // Fonction de mise à jour des prix
    const updatePricing = () => {
      setPricing(getPricing());
    };

    // Observer les changements dans le DOM
    const observer = new MutationObserver(() => {
      updatePricing();
    });

    // Observer les changements sur tout le body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-pix-price', 'data-pix-original', 'data-pix-discount',
        'data-album-carre-price', 'data-album-carre-original', 'data-album-carre-discount',
        'data-album-paysage-price', 'data-album-paysage-original', 'data-album-paysage-discount',
        'data-album-premium-price', 'data-album-premium-original', 'data-album-premium-discount',
        'data-tirages-photos-price', 'data-tirages-photos-original', 'data-tirages-photos-discount',
        'data-yearbook-price', 'data-yearbook-original', 'data-yearbook-discount'
      ],
    });

    // Nettoyage
    return () => {
      observer.disconnect();
    };
  }, []);

  return pricing;
}
